


















import { Component, Vue } from 'vue-property-decorator'
import { RouteConfig } from 'vue-router'
import SidebarItem from '@/components/sidebar/SidebarItem.vue'
import { SidebarType } from '@/store/modules/layout'
import { namespace } from 'vuex-class'

const layoutModule = namespace('layout')
const appModule = namespace('app')

@Component({ components: { SidebarItem } })
export default class SideBar extends Vue {
  @layoutModule.State sidebar!: SidebarType
  @appModule.State isUserAdmin!: boolean

  get routes(): any {
    return (this.$router as any).options.routes.filter((route: RouteConfig) => {
      return this.needsAdminRole(route) && !this.isHidden(route)
    })
  }

  get isCollapse(): boolean {
    return !this.sidebar.opened
  }

  get activeLink(): string {
    return this.$route.path
  }

  isHidden(route: RouteConfig): boolean {
    return route.meta && route.meta.isHidden
  }

  needsAdminRole(route: RouteConfig): boolean {
    if (route.meta && route.meta.needsAdminRole) {
      return this.isUserAdmin
    }

    return true
  }
}
